import React from 'react';
import styled from 'styled-components';

const ContentBlock = props => {
  return (
    <Root {...props}>
      <h1>{props.title}</h1>
      <p>{props.body}</p>
    </Root>
  );
};

const Root = styled.div`
  padding: 80px 20px;
  max-width: 750px;
  margin: 0 auto;
  h1 {
    color: ${props => props.theme.colorPrimary};
    font-family: ${({ theme }) => theme.fontHeader};
    text-transform: uppercase;
    font-size: 28px;
    max-width: 370px;
    margin: 0 auto 30px;
  }
  p {
    font-family: ${({ theme }) => theme.fontMain};
    color: rgba(0, 0, 0, 0.72);
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0;
  }
  strong {
    font-weight: normal;
    color: #ff7802;
  }
`;

export default ContentBlock;



// WEBPACK FOOTER //
// ./src/components/ContentBlock.js